import 'simplebar';

document.addEventListener('click', function (event) {

}, false);